var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","text":"","color":"secondary"}},[_vm._v("Dismiss")])
}
var staticRenderFns = []

export { render, staticRenderFns }